import axios from 'axios';
import jwt_decode from "jwt-decode";
import { BASE_CONSTANTS } from './config';

class AuthService {

  login(user) {

    var dados = {
      username: user.username,
      password: user.password
    }

    return axios.post('auth/login', dados, {
      baseURL: BASE_CONSTANTS.urlBase,
      headers: {
        'Content-Type': 'application/json'
      },
      withCredentials: true
    }).then(response => {
      
      if (response && response.data.accessToken) {

        let token = JSON.stringify(response.data.accessToken)
        let decoded = jwt_decode(token);
        
        localStorage.setItem('authorization', JSON.stringify(response.data.accessToken))
        //localStorage.setItem('refresh_token', JSON.stringify(response.data.refresh_token))
        
        let http = axios.create({
          baseURL: BASE_CONSTANTS.urlBase,
          headers: {
            'Authorization': 'bearer ' + String(token).replaceAll('"', ''),
            'Content-Type': 'application/json',
            'Accept': '*/*'
          }          
        })

        return http.get('usuario/dados?login=' + decoded.sub)
          .then(resposta => {            
            let retorno = resposta.data;
            let user = retorno.obj;            
            localStorage.setItem('dadosUsuario', JSON.stringify(user))                        
            return user;            
          })

      } else {
        throw new Error('Usuário e/ou senha incorreto(s)');
      }

    }).catch(error => {
      return Promise.reject(error);
    });

  }
  logout() {
    localStorage.removeItem('dadosUsuario');
    localStorage.setItem('authorization', null)
    localStorage.setItem('refresh_token', null)      
      
      let http = axios.create({
        baseURL: BASE_CONSTANTS.urlBase,
        headers: {
          'Content-Type': 'application/json',
          'Accept': '*/*'
        },
        withCredentials: true
      })

      http.post('auth/logout')
        .then(resposta => {           
          let retorno = resposta.data;
        }).catch(error => {
        return Promise.reject(error);
      });    
  }
  register(user) {
    return axios.post(API_URL + 'signup', {
      username: user.username,
      email: user.email,
      password: user.password
    });
  }


}
export default new AuthService();